export class CONSTANTS { 
    static APP_ID = '22062016';
    static APP_VERSION = 'v1.0';
    static DEVICE_ID = 'web-dev-admin1';
    static DEVICE_TYPE = 'web';
}